<ng-container thr-parent-form>
    <div class="container">
        <div class="row mt-5">
            <div class="col-6 col-lg-6">
                <mat-form-field class="full-width no-padding-bottom" [class.mat-form-field-invalid]="amountCtrl.errors">
                    <mat-label>{{ 'form.amount-to-subscribe' | translate }}</mat-label>
                    <input
                        type="hidden"
                        name="amount"
                        [min]="minimumInvestment"
                        [max]="maximumInvestment"
                        [(ngModel)]="selectedProduct.order.amount"
                        #amountCtrl="ngModel"
                    />
                    <input
                        matInput
                        #autoNumericDirective="auto-numeric"
                        thr-auto-numeric
                        [placeholder]="'form.hints.amount' | translate"
                        required
                        [disabled]="!editable"
                        [value]="initialAmount"
                        (input)="onAmountChange()"
                    />
                </mat-form-field>
                <div class="mb-3 mb-sm-4">
                    <mat-error class="d-block mat-caption" *ngIf="amountCtrl.hasError('max') && !amountCtrl.hasError('required')">
                        {{
                            'form.validation.maximum-amount'
                                | translate
                                    : {
                                          value: maximumInvestment | number: '1.0-2'
                                      }
                        }}
                    </mat-error>
                    <mat-error class="d-block mat-caption" *ngIf="amountCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </div>
            </div>
            <!--Nuevo ADV-2351-->
            <div class="col-6 col-md-8 col-lg-6">
                <div class="product-summary">
                <ng-container *ngIf="canExonerate">
                    <div class="py-4 py-md-0">
                        <label class="mb-0">
                            {{ 'product.convenience' | translate }}
                            <span class="appropriateness ml-4" [class.not-appropriateness]="!selectedProduct.isAppropriateness">
                                <mat-icon>check</mat-icon>
                            </span>
                        </label>
                    </div>
                    <div class="d-flex">
                        <label class="mt-1 mb-0 mt-md-0">{{ 'product.exonerate' | translate }}</label>
                        <mat-radio-group class="ml-4" [disabled]="true" *ngIf="selectedProduct.isAppropriateness">
                            <mat-radio-button color="blue-gray" [value]="false">
                                {{ 'general.no' | translate }}
                            </mat-radio-button>
                            <mat-radio-button class="ml-5" color="blue-gray" [value]="true">
                                {{ 'general.yes' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                        <mat-radio-group class="ml-4"  name="isExonerated" [disabled]="!editable" [(ngModel)]="selectedProduct.isExonerated" (ngModelChange)="onExonerate()" *ngIf="!selectedProduct.isAppropriateness">
                            <mat-radio-button color="blue-gray" [value]="false">
                                {{ 'general.no' | translate }}
                            </mat-radio-button>
                            <mat-radio-button class="ml-5" color="blue-gray" [value]="true">
                                {{ 'general.yes' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </ng-container>
                </div>
            </div>
            <!--Fin de Nuevo ADV-2351-->
        </div>
        <div class="row">
            <div class="col-12 col-md-4">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-label>{{ 'form.period-subscription-start-date' | translate }}</mat-label>
                    <input
                        name="startDate"
                        matInput
                        [min]="minStartDate"
                        [matDatepickerFilter]="filterWeekend"
                        [matDatepicker]="startDatePicker"
                        required
                        maxlength="10"
                        [disabled]="!editable"
                        [placeholder]="'form.hints.date' | translate"
                        [(ngModel)]="selectedProduct.order.periodOrderStartDate"
                        #documentPeriodStartDateCtrl="ngModel"
                    />
                    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #startDatePicker [disabled]="!editable"></mat-datepicker>
                    <mat-error *ngIf="!documentPeriodStartDateCtrl.valid">
                        {{ 'form.validation.invalid.date' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-md-7 offset-md-1 col-lg-6 offset-lg-2 mb-5">

                <label>{{ 'form.period' | translate }}</label
                ><br />
                <mat-radio-group
                    name="numberOfMonths"
                    required
                    [disabled]="!editable"
                    [(ngModel)]="selectedProduct.order.periodNumberOfMonths"
                >
                    <mat-radio-button [value]="1">{{ 'form.period-monthly' | translate }}</mat-radio-button>
                    <mat-radio-button [value]="3">{{ 'form.period-quarterly' | translate }}</mat-radio-button>
                    <mat-radio-button [value]="6">{{ 'form.period-semiannual' | translate }}</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <!-- <div class="row flex-nowrap align-items-center">
            <div class="col-auto pr-0">
                <i class="icon-exclamation gray-icon-exclamation"></i>
            </div>
            <div class="col-auto flex-shrink-1 pl-2">
                <p class="mat-caption text-error font-italic mb-0">
                    <span [innerHTML]="'operative.transfer-money-iban' | translate"></span><br />
                    <strong class="text-body">{{ product.iban }}</strong>
                </p>
            </div>
        </div> -->
    </div>
</ng-container>
